import React, { useState, useEffect } from "react";
import {
  FaChevronLeft,
  FaChevronRight,
  FaUsers,
  FaRocket,
  FaSync,
  FaDatabase,
} from "react-icons/fa";

const useCases = [
  {
    title: "Lead Generation",
    description:
      "Capture and verify leads automatically from web forms, ensuring accurate and up-to-date data. Seamlessly integrate with your CRM to boost conversions and efficiency.",
    icon: FaUsers,
  },
  {
    title: "Sales Outreach",
    description:
      "Automatically find, validate, and send verified email addresses to your sales pipeline. Reduce bounce rates and improve engagement with potential clients.",
    icon: FaRocket,
  },
  {
    title: "Marketing Automation",
    description:
      "Sync verified email lists with platforms like Mailchimp, HubSpot, or other marketing tools. Improve campaign targeting and maximize ROI effortlessly.",
    icon: FaSync,
  },
  {
    title: "Data Enrichment",
    description:
      "Enhance your existing contact database by fetching and validating accurate email addresses. Get a complete view of your customer data with automated enrichment.",
    icon: FaDatabase,
  },
];

export default function PopularUseCases() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCards, setVisibleCards] = useState(getVisibleCards());

  function getVisibleCards() {
    if (window.innerWidth >= 1280) return 3; // Desktop
    if (window.innerWidth >= 768) return 2; // Tablet
    return 1; // Mobile
  }

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % useCases.length);
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? useCases.length - 1 : prevIndex - 1
    );
  };

  const displayedUseCases = [];
  for (let i = 0; i < visibleCards; i++) {
    displayedUseCases.push(useCases[(currentIndex + i) % useCases.length]);
  }

  useEffect(() => {
    const handleResize = () => {
      setVisibleCards(getVisibleCards());
      setCurrentIndex(0);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="bg-white py-12 px-5 flex flex-col items-center">
      <h2 className="text-3xl text-black py-6 sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold text-center md:py-16">
        Popular Use Cases
      </h2>
      <div className="flex items-center w-full max-w-6xl">
        <button
          onClick={handlePrevious}
          className="text-[#4f7fff] text-3xl p-3 rounded-full"
        >
          <FaChevronLeft />
        </button>
        <div className="flex gap-6 mx-4 overflow-hidden w-full justify-center">
          {displayedUseCases.map((useCase, index) => {
            const IconComponent = useCase.icon;
            return (
              <div
                key={index}
                className="bg-slate-50 p-8 rounded-xl border border-gray-200 w-[400px] xl:w-[420px] h-[380px] flex flex-col items-center text-center"
              >
                <IconComponent className="text-4xl text-[#4f7fff] my-4" />
                <h3 className="text-2xl font-bold text-gray-900">
                  {useCase.title}
                </h3>
                <p className="text-gray-700 mt-4 text-lg leading-relaxed max-w-[320px]">
                  {useCase.description}
                </p>
              </div>
            );
          })}
        </div>
        <button
          onClick={handleNext}
          className="text-[#4f7fff] text-3xl p-3 rounded-full"
        >
          <FaChevronRight />
        </button>
      </div>
    </div>
  );
}
